module.exports = __webpack_public_path__ + "img/1538307781.a6e86fb9.jpg";